/**
 * How a derived order status is shown, everywhere it is shown.
 *
 * The status itself is not stored: `deriveOrderStatus` computes it from the
 * cutoff. These two maps are the single source of truth for its
 * label and colour, so the proposal screen and the order-history screens can
 * never render the same status differently.
 */
import type { OrderStatus } from '@retail/orders-domain'

export type { OrderStatus }

export const STATUS_LABELS: Record<OrderStatus, string> = {
  EDITABLE: 'Editable',
  CLOSED: 'Cerrado',
}

export const STATUS_BG: Record<OrderStatus, 'light-olive' | 'cream'> = {
  EDITABLE: 'light-olive',
  CLOSED: 'cream',
}
